import { combineReducers } from 'redux';

import analyticsDataReducer from './analyticsDataReducer';
import dateRangeReducer from './dateRangeReducer';

export default combineReducers({
  dateRange: dateRangeReducer,
  periodData: analyticsDataReducer
});
